import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { CANCELLED_WITH_VENDOR, CANCELLED_WITH_VENDOR_ERROR, CANCELLED_WITH_VENDOR_SUCCESS } from '../../../actions.js';

function* cancelledWithVendor({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/cancel-with-vendor`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
      data: {
        ...payload?.data,
      },
    });

    if (response.status === 200) {
      if (response?.data?.code == 4089) cogoToast.warn(response?.data?.message);
      else cogoToast.success(response?.data?.message);
      yield put({
        type: CANCELLED_WITH_VENDOR_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CANCELLED_WITH_VENDOR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CANCELLED_WITH_VENDOR_ERROR, payload: error });
  }
}

export function* watchcancelledWithVendor() {
  yield takeEvery(CANCELLED_WITH_VENDOR, cancelledWithVendor);
}

function* cancelledWithVendorSaga() {
  yield all([fork(watchcancelledWithVendor)]);
}

export default cancelledWithVendorSaga;
